import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.2 14.077c.271.27.639.423 1.022.423h7.222a1.444 1.444 0 0 0 1.444-1.444V6.132a.72.72 0 0 0-.211-.51l-3.91-3.91a.72.72 0 0 0-.51-.212H4.221a1.444 1.444 0 0 0-1.445 1.444v10.112c0 .383.153.75.423 1.02m7.55-6.8a.75.75 0 0 0-1.5 0v4.334a.75.75 0 0 0 1.5 0zM8.583 8.723a.75.75 0 0 0-1.5 0v2.89a.75.75 0 0 0 1.5 0zm-2.167 1.445a.75.75 0 0 0-1.5 0v1.444a.75.75 0 0 0 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }